import { createSelector } from "reselect";
import get from "lodash/get";
import { forms } from "utils/constants";
import { getDeviceId } from "utils/localStorage";
import { isMobile } from "utils/helpers";

/**
 * Extracting Login OTP from values
 * @param {object} state
 */
const emailOtpDomain = state => get(state, "api.emailOtp", {});
const validateEmailOtpDomain = state =>
  get(state, "api.validateEmailOtp.data", {});
/**
 * Extracting Login OTP from values
 * @param {object} state
 */
const personalDetailsFormSelector = state =>
  get(state, `form.${forms.PERSONAL_DETAILS_FORM}.values`, {});

/**
 * ************ OTP Form Selectors ************
 */
export const makeSelectEmailOtp = () =>
  createSelector(emailOtpDomain, emailOtp => {
    return get(emailOtp, "data.auth_id", "");
  });

export const makeSelectEmailOtpParams = () =>
  createSelector(emailOtpDomain, emailOtp => {
    return get(emailOtp, "params", {});
  });

export const makeSelectEmailOtpPayload = () =>
  createSelector(personalDetailsFormSelector, personalDetails => {
    return {
      auth_mode: "ENHANCED_EMAIL_OTP",
      request_type: "GENERIC_VERIFY_EMAIL",
      otp_duration: 15,
      mock: false,
      device_id: getDeviceId(),
      email: get(personalDetails, "email")
    };
  });

export const makeSelectValidateEmailOtpPayload = () =>
  createSelector(
    personalDetailsFormSelector,
    emailOtpDomain,
    (personalDetails, emailOtp) => {
      const otpCode = get(personalDetails, "current_otp", []).join("");
      return {
        auth_id: get(emailOtp, "data.auth_id", ""),
        otp_code: otpCode,
        device: {
          device_id: getDeviceId(),
          device_type: isMobile ? "Mobile" : "web"
        }
      };
    }
  );

export const makeSelectEmailOtpMessageData = () =>
  createSelector(personalDetailsFormSelector, personalDetails => {
    return {
      email: get(personalDetails, "email"),
      contactNumber: get(personalDetails, "contact_number")
    };
  });

export const makeSelectIsValidatedEmail = () =>
  createSelector(
    validateEmailOtpDomain,
    personalDetailsFormSelector,
    emailOtpDomain,
    (validateEmailOtp, personalInfoForm, emailOtp) => {
      return (
        get(emailOtp, "data.auth_id", false) &&
        get(emailOtp, "params.email", null) ===
          get(personalInfoForm, "email") &&
        get(validateEmailOtp, "status", null) === "OTP_VALIDATED"
      );
    }
  );
